import api from '@/utils/axiosInterceptor';

import type {
  NotificationResponse,
  UnreadCountResponse,
} from '../types/notification.types';

export class NotificationApiService {
  async fetchNotifications(page = 1): Promise<NotificationResponse> {
    const response = await api.get(
      `/notifications/my-notifications?page=${page}`,
    );
    return response.data;
  }

  async fetchNotificationsAfter(
    timestamp: number,
    limit = 10,
  ): Promise<NotificationResponse> {
    const response = await api.get(
      `/notifications/my-notifications?after=${timestamp}&limit=${limit}`,
    );
    return response.data;
  }

  async fetchUnreadCount(): Promise<UnreadCountResponse> {
    const response = await api.get('/notifications/unread-count');
    return response.data;
  }

  async markAsRead(notificationId: string): Promise<void> {
    await api.patch(`/notifications/mark-as-read/${notificationId}`);
  }

  async markAllAsRead(): Promise<void> {
    await api.patch('/notifications/read-all');
  }
}

export const notificationApi = new NotificationApiService();
